import * as React from 'react';
import { Header, Navigation, Filter, Footer } from '../../shared';
import { Grid, Typography, Tab, AppBar, Tabs, LinearProgress, Paper } from '@material-ui/core';

import './PublisherSale.scss';

import {
  PublisherBookFilter,
  PublisherBookstoreFilter,
  PublisherEconomicGroupFilter,
  PublisherPublisherFilter,
  // PublisherStampFilter,
  PublisherUfFilter,
  PublisherBisacFilter,
  PublisherAuthorFilter
} from '../shared/filter';

import {
  PublisherRevenue30Days,
  PublisherMarketShare,
  PublisherMonthComparative,
  PublisherRegionShare,
  PublisherStoreShare,
  PublisherBookstoreShare,
  SubjectShare,
  PublisherSkuSold,
  PublisherCategoryPnShare,
  PublisherCategoryBisacShare
} from '.';

import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { PublisherFilterChip } from '../shared/chips/PublisherFilterChip';

import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { QueryFilter, QUERY_FILTER_PUBLISHER } from '../../shared';
import { GetCacheIfExists, SetDataToSession, HasNoFilterAppliedPublisherShare } from '../../shared/cache/Cache';
import { PublisherDateFilter } from '../shared/filter/publisher-date-filter/PublisherDateFilter';
import { PublisherEconomicGroupShare } from './economic-group-share/PublisherEconomicGroupShare';
import { PublisherSkuSoldAnalytical } from './sku-sold-analytical/PublisherSkuSoldAnalytical';
import { PublisherSalesLastYears } from './sales-last-years/PublisherSalesLastYears';
import { PublisherSalesCurrentYear } from './sales-current-year/PublisherSalesCurrentYear';
import { PublisherBisacCodeFilter } from '../shared/filter/publisher-bisac-code-filter/PublisherBisacCodeFilter';
import { PublisherCategoryStore } from './category-store/PublisherCategoryStore';
import ShareMonthlyEvolution from './share-mothly-evolution/ShareMonthlyEvolution';
import ShareEvolutionWeekly from './evolution-weekly/ShareEvolutionWeekly';

const PUBLISHER_STORE_SHARE = gql`
query publisherStoreShare($customFilter:  PublisherCustomFilter) {
    publisherStoreShare(publisherCustomFilter: $customFilter) {
        billing,
        name,
        value,
        volume
    }
}
`;


const PUBLISHER_STORE_SHARE_MARKET = gql`
query publisherStoreMarketShare($customFilter:  PublisherCustomFilter) {
    publisherStoreMarketShare(publisherCustomFilter: $customFilter) {
        name,
        value
    }
}
`;

const PUBLISHER_SKU_SOLD = gql`
query publisherSkuSold($customFilter:  PublisherCustomFilter) {
    publisherSkuSold(publisherCustomFilter: $customFilter) {
        month,
        monthName,
        qtdPublished,
        qtdSold
    }
}
`;
const PUBLISHER_SKU_SOLD_ANALYTICAL = gql`
query publisherSkuSoldAnalytical($customFilter:  PublisherCustomFilter) {
  publisherSkuSoldAnalytical(publisherCustomFilter: $customFilter) {
        month,
        monthName,
        prdNotSoldList {
            sku,
            title
        },
        prdSoldList {
            sku,
            title
        }
    }
}
`;

// tslint:disable-next-line:no-empty-interface
export interface IPublisherSaleProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IPublisherSaleState {
  customFilter: {
    isChart: boolean
  },
  monthSkuSoldAnalyticalView: number,
  tabValue: number,
  waitDataFilter: boolean,
}

function TabContainer(props: any) {
  return (
      <Typography component="div" style={{ paddingTop: 8 * 3 }}>
          {props.children}
      </Typography>
  );
}

function LinkTab(props: any) {
  return (
    // tslint:disable-next-line:jsx-no-lambda
    <Tab component="a" onClick={event => event.preventDefault()} {...props} />
  );
}

export class PublisherSale extends React.Component<IPublisherSaleProps, IPublisherSaleState> {
  constructor(props: IPublisherSaleProps) {
    super(props);
    this.state = {
      customFilter: {
        isChart: true,
      },
      monthSkuSoldAnalyticalView: 12,
      tabValue: 0,
      waitDataFilter: false,
    }
    this.changeMonthSkuSoldReference = this.changeMonthSkuSoldReference.bind(this);
    this.finishLoad = this.finishLoad.bind(this);
    
  }
 

  public finishLoad () {
    this.setState({ waitDataFilter: false });
  } 

  public isAdmin() {
    const perfis = [ 'admin', 'bookinfo@vozes.com.br', 'teobaldo@vozes.com.br']
    const user = window.sessionStorage.getItem("user");
    const item =  user ? JSON.parse(user) : null; 
    return item && item.email && perfis.includes(item.email)
  }

  public render() {    
    const jsonFilter = {
      "customFilter": {
        "isChart": this.state.customFilter.isChart,
      }
    };

    let filters = [
      <PublisherEconomicGroupFilter key={1} />,
      <PublisherPublisherFilter key={2} />,
      // <PublisherStampFilter key={3} />,
      <PublisherBookstoreFilter key={4} />,
      <PublisherUfFilter key={5} />,
      <PublisherBookFilter key={6} />,
      <PublisherBisacFilter key={7} />,
      <PublisherAuthorFilter key={8} />,
      <PublisherBisacCodeFilter key={9} />
    ];
    if(this.state.tabValue === 1) {
      filters.push(<PublisherDateFilter key={7} finishLoad={this.finishLoad} />);
    }

    if (this.state.tabValue === 5) {
      filters = [
        <PublisherEconomicGroupFilter key={1} />,
        <PublisherBookstoreFilter key={4} />,
        <PublisherUfFilter key={5} />,
        <PublisherBisacFilter key={7} />,
        <PublisherBisacCodeFilter key={9} />
      ]
    }  
    if (this.state.tabValue === 6) {
      filters = [
        <PublisherPublisherFilter key={2} />, 
        <PublisherBisacFilter key={7} />,      
      ]
    }

    if (this.state.tabValue === 3) {
      filters = [
        <PublisherPublisherFilter key={2} />, 
        <PublisherBisacFilter key={7} />,      
      ]
    }

    return (
      <div>
        <Header
          title={"Análises"}
          name={"Editoras"}
          link={'/dashboard'}
        />
        <Navigation
          name={"Painel de Vendas"}
          linkDefault={"/publisher/sale"}
          link={"/publisher/analytical"}
          linkTitle={"Analítico"}
          painel={1}
          icon={<ChevronRightIcon />}
        />

        <Filter filters={filters} />

        <PublisherFilterChip />

        {this.state.waitDataFilter ? <LinearProgress /> : 
        <div className="wrapper">
          <AppBar position="static" style={{ backgroundColor: '#FFFF' }}>
            <Tabs fullWidth={true} value={this.state.tabValue} onChange={this.handleChangeTab} centered={true}
              textColor="primary" indicatorColor="primary">
              <LinkTab label="Vendas" href="page1" />
              <LinkTab label="Share" href="page2" />
              <LinkTab label="Acervo" href="page3" />
              <LinkTab label="Evolução Semanal 2.0" href="page4" />
              <LinkTab label="Categorias" href="page5" />
              <LinkTab label="Categorias x Lojas" href="page6" />
              <LinkTab label="Evolução Share Mensal" href="page7" /> 
            </Tabs>
          </AppBar>

          {this.state.tabValue === 0 && <TabContainer>
              <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16}>

                  <Grid item={true} xs={12} md={12}>
                    <Grid container={true} className="publisher-sale-panel panel-grid panel-bg-area" spacing={16}>
                      <Grid item={true} xs={12} className="panel-bg" >
                        <Typography component="h3" className="panel-head">
                          Ano atual
                        </Typography>
                        <PublisherSalesCurrentYear />
                      </Grid>

                      <Grid item={true} xs={12} className="panel-bg" >
                        <Typography component="h3" className="panel-head">
                          Anos Anteriores
                        </Typography>
                        <PublisherSalesLastYears />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item={true} xs={12}>
                    <PublisherMonthComparative />
                  </Grid>

                  <Grid item={true} xs={12}>
                    <PublisherRevenue30Days />
                  </Grid>
              </Grid>
          </TabContainer>}

          {this.state.tabValue === 1 && <TabContainer>
            <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16}>

              <Grid item={true} xs={12} md={12}>
                <PublisherRegionShare />
              </Grid>

              <Grid item={true} xs={6} md={6}>
                <PublisherMarketShare />
              </Grid>

              <Grid item={true} xs={6}>
                <SubjectShare />
              </Grid>

              <Grid item={true} xs={12}>
                <Query query={QUERY_FILTER_PUBLISHER} notifyOnNetworkStatusChange={true}  >
                    {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {

                        let dataCache = GetCacheIfExists('publisher-data');
                        const hasNoFilterAppliedPublisher = HasNoFilterAppliedPublisherShare(clientC);

                        if( hasNoFilterAppliedPublisher && dataCache != null && dataCache.publisherStoreShare != null ) {
                            if(dataCache.publisherStoreMarketShare != null) {
                                return this.storesGraphics(dataCache.publisherStoreShare, dataCache.publisherStoreMarketShare, false);
                            } else {
                                return this.searchMarket(hasNoFilterAppliedPublisher, dataCache, clientC, dataCache.publisherStoreShare, false);
                            }
                        } else {
                            return (
                                <Query query={PUBLISHER_STORE_SHARE} variables={QueryFilter.getFilterPublisher(clientC, jsonFilter, [])}>
                                    {({ loading, error, data: dataStore, client}) => {
                                        if (hasNoFilterAppliedPublisher && dataStore != null && dataStore.publisherStoreShare != null) {
                                            if(dataCache != null && dataCache !== undefined) {
                                                dataCache.publisherStoreShare = dataStore.publisherStoreShare;
                                            } else {
                                                dataCache = dataStore;
                                            }
                                            SetDataToSession('publisher-data', dataCache);
                                        }

                                        return this.searchMarket(hasNoFilterAppliedPublisher, dataCache, clientC, dataStore.publisherStoreShare, loading);
                                    }}
                                </Query>
                            );
                        }

                    }}
                </Query>
              </Grid>

            </Grid>
          </TabContainer>}
          {this.state.tabValue === 2 && <TabContainer>
            {this.rendAcervoData(jsonFilter)}
          </TabContainer>}
          {this.state.tabValue === 3 && <TabContainer>
            {this.rendCategoryTab(jsonFilter, 'shareweekly')}
          </TabContainer>}
          {this.state.tabValue === 4 && <TabContainer>
            {this.rendCategoryTab(jsonFilter, 'category')}
          </TabContainer>}
          {this.state.tabValue === 5 && <TabContainer>
            {this.rendCategoryTab(jsonFilter, 'categoryxstore')}
          </TabContainer>}
          {this.state.tabValue === 6 && <TabContainer>
            {this.rendCategoryTab(jsonFilter, 'sharemensal')}
          </TabContainer>}
        </div>}
        <Footer />
      </div>
    );
  }

  private rendAcervoData(jsonFilter:any) {
    return (
      <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16}>
        <Grid item={true} xs={12} md={12}>
          <Query query={QUERY_FILTER_PUBLISHER} notifyOnNetworkStatusChange={true}  >
              {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                  return (
                      <Query query={PUBLISHER_SKU_SOLD} variables={QueryFilter.getFilterPublisher(clientC, jsonFilter, ['endDate', 'initialDate'])}>
                          {({ loading, error, data, client }) => {
                            return(
                                <Query query={PUBLISHER_SKU_SOLD_ANALYTICAL} variables={QueryFilter.getFilterPublisher(clientC, jsonFilter, ['endDate', 'initialDate'])}>
                                    {({ loading:loadingAnalytical, error: errorAnalytical, data: dataAnalytical, client: clientAnalytical }) => {
                                        
                                        let analyticalSoldList = [];
                                        let analyticalNotSoldList = [];
                                        let monthName = "";
                                        let monthSkuSoldAnalyticalView = this.state.monthSkuSoldAnalyticalView;
                                        if(dataAnalytical && dataAnalytical.publisherSkuSoldAnalytical && dataAnalytical.publisherSkuSoldAnalytical.length > 0) {

                                          if(monthSkuSoldAnalyticalView > dataAnalytical.publisherSkuSoldAnalytical.length) {
                                            monthSkuSoldAnalyticalView = dataAnalytical.publisherSkuSoldAnalytical.length;
                                          }

                                          analyticalSoldList = dataAnalytical.publisherSkuSoldAnalytical[monthSkuSoldAnalyticalView -1].prdSoldList;
                                          analyticalNotSoldList = dataAnalytical.publisherSkuSoldAnalytical[monthSkuSoldAnalyticalView -1].prdNotSoldList;

                                          monthName = " - " + dataAnalytical.publisherSkuSoldAnalytical[monthSkuSoldAnalyticalView -1].monthName;
                                        }
                                        
                                        return (
                                          <Grid container={true} spacing={16}>
                                            <Grid item={true} xs={12} md={12}>
                                              <PublisherSkuSold data={data} loading={loading} changeMonthSkuSoldReference={this.changeMonthSkuSoldReference} />
                                            </Grid>

                                            <Grid item={true} xs={6} md={6}>
                                              <PublisherSkuSoldAnalytical list={analyticalSoldList} loading={loadingAnalytical} title={"Produtos Vendidos"+monthName} />
                                            </Grid>

                                            <Grid item={true} xs={6} md={6}>
                                              <PublisherSkuSoldAnalytical list={analyticalNotSoldList} loading={loadingAnalytical} title={"Produtos Não Vendidos"+monthName} />
                                            </Grid>
                                          </Grid>
                                        );

                                    }}
                                </Query>
                            );
                          }}
                      </Query>
                  );
              }}
          </Query>
        </Grid>
      </Grid>
    );
  }

  private rendCategoryTab(jsonFilter:any, tab: string) {
    return (
      <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16}>
        <Grid item={true} xs={12} md={12}>
          <Query query={QUERY_FILTER_PUBLISHER} notifyOnNetworkStatusChange={true} partialRefetch={true}  >
              {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                  const filter = QueryFilter.getFilterPublisher(clientC, jsonFilter, ['endDate', 'initialDate', 'publishers']);

                  if(tab === 'sharemensal') {
                    return <ShareMonthlyEvolution filter={filter} client={ clientC } loading={ loadingC } />
                  }

                  if(tab === 'shareweekly') {
                    return <ShareEvolutionWeekly filter={filter} client={ clientC } loading={ loadingC } />
                  }
                  return tab === 'category' ? this.rendCategoryData(filter) : this.rendCategoryStoreTab(filter)
              }}
          </Query>
        </Grid>
      </Grid>
    );
  }

  private rendCategoryData(filter:any) {
    if(filter.customFilter.groups && filter.customFilter.groups.length === 1) {
      return (
        <Grid container={true} spacing={16}>
            <Grid item={true} xs={12} md={12}>
                <PublisherCategoryPnShare filter={filter} />
                <PublisherCategoryBisacShare filter={filter} />
            </Grid>
        </Grid>
      );
    } else if (filter.customFilter.groups && filter.customFilter.groups.length > 1) {
      return this.getFilterMsg("Escolha apenas um Grupo Econômico");
    } else {
      return this.getFilterMsg("Escolha um Grupo Econômico");
    }
  }

  private rendCategoryStoreTab (filter: any) {
    if ((filter.customFilter.bisac.length > 0) || (filter.customFilter.bisac_code.length > 0)) {
      return <PublisherCategoryStore filter={filter} />;
    }
    return this.getFilterMsg("Escolha pelo menos uma Categoria ou Bisac")
  }

  private getFilterMsg = (msg: string) => {
    return (
      <Paper className="requiredFilterPaper">
        <Typography
          align="center"
          variant="title"
          className="requiredFilterMessage"
        >
          {msg}
        </Typography>
      </Paper>
    );
  }

  // private rendWeeklyEvolutionTab () {
  //   return (
  //     <PublisherWeeklyEvolution />
  //   );
  // }

  private changeMonthSkuSoldReference (month:number) {
    this.setState({monthSkuSoldAnalyticalView: month});
  }

  private searchMarket (hasNoFilterAppliedPublisher: boolean, dataCache:any, clientC: any, dataStoreArray: any[], loadingStore:boolean) {

    const jsonFilter = {
        "customFilter": {
          "isChart": this.state.customFilter.isChart,
        }
    };
    return (
        <Query query={PUBLISHER_STORE_SHARE_MARKET} variables={QueryFilter.getFilterPublisher(clientC, jsonFilter, ['bookstores', 'books', 'publishers'])}>
            {({ loading, error, data: dataMarket, client}) => {

                if ( hasNoFilterAppliedPublisher && dataMarket != null && dataMarket.publisherStoreMarketShare != null ) {
                    if(dataCache != null && dataCache !== undefined) {
                        dataCache.publisherStoreMarketShare = dataMarket.publisherStoreMarketShare;
                    } else {
                        dataCache = dataMarket;
                    }
                    SetDataToSession('publisher-data', dataCache);
                }

                return this.storesGraphics(dataStoreArray, dataMarket.publisherStoreMarketShare,(loading || loadingStore));
            }}
        </Query>
    );
  }

  private storesGraphics (dataStoreArray:any[], dataMarketArray:any[], loading:any) {
    return (
      <Grid container={true} spacing={16}>
        <Grid item={true} xs={8} md={8}>
          <PublisherStoreShare dataStoreArray={dataStoreArray} dataMarketArray={dataMarketArray} loading={loading} />
        </Grid>

        <Grid item={true} xs={4} md={4}>
          <PublisherBookstoreShare dataStoreArray={dataStoreArray} dataMarketArray={dataMarketArray} loading={loading} />
        </Grid>

        <Grid item={true} xs={12} md={12}>
          <PublisherEconomicGroupShare />
        </Grid>
      </Grid>
    );
  }

  private handleChangeTab = (event: any, tabValue: any) => {
    let waitDataFilter = Object.assign({}, this.state.waitDataFilter);
    if(tabValue === 1) {
      waitDataFilter = true;
    } else {
      waitDataFilter = false;
    }

    this.setState({ tabValue, waitDataFilter });
  };

}



// WEBPACK FOOTER //
// ./src/component/publisher/sale/PublisherSale.tsx